import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PanoramaOutlinedIcon from '@mui/icons-material/PanoramaOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {ASPECT_RATIOS} from '@explorer/util/snapshot';
import {
  SnapshotMenuButton,
  ToggleButton,
  ToggleButtonGroup,
} from './snapshot.styles.jsx';

const AspectRatioMenu = props => {
  const {t} = useTranslation();

  const handleChange = (event, newValue) => {
    props.onChange(newValue);
  };

  return (
    <SnapshotMenuButton
      label={<PanoramaOutlinedIcon />}
      tooltipTitle={t('snapshot.tooltipAspectRatioMenu')}
      data-qe="snapshot-aspect-ratio-button"
    >
      <ToggleButtonGroup value={props.value} onChange={handleChange}>
        <ToggleButton
          value={ASPECT_RATIOS.wide}
          tooltipTitle={t('snapshot.tooltipRatio16x9')}
        >
          <PanoramaOutlinedIcon />
        </ToggleButton>

        <ToggleButton
          value={ASPECT_RATIOS.square}
          tooltipTitle={t('snapshot.tooltipRatio1x1')}
        >
          <ImageOutlinedIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </SnapshotMenuButton>
  );
};

AspectRatioMenu.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AspectRatioMenu;
